<template>
  <div>
    <div class="model-top-box">
      <el-row>
        <el-input
          :placeholder="$t('couponList.searchMember')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="handleSearch"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="handleSearch" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="handleReset(['active'])" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </div>
    <div class="flexBC user-list">
      <p class="title-list">사용자 리스트</p>
      <p class="title-selected">선택됨 (<span class="title-selected-count">{{ selectedCount }}</span>)</p>
      <my-table
        ref="myTable"
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="true"
        :cellStyle="{ padding: '6px 0' }"
        :rowStyle="{ height: '48px' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="handleSelectionChange"
        @sortChange="sort_change"
      >
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </div>


    <span slot="footer" class="dialog-footer">
      <el-button @click="done('close')" type="default" class="ml30">{{
        $t('btnTip.close')
      }}</el-button>
      <el-button @click="done('all')" type="primary" class="ml30">{{
        $t('addAllMember')
      }}</el-button>
      <el-button @click="done('selected')" type="primary" class="ml30">{{
        $t('btnTip.submit')
      }}</el-button>
    </span>
  </div>
</template>
<script>
import { mixin_list } from '@/mixins';
import page from '@/components/page';
import myTable from '@/components/table';
import FormPage from '@/components/FormPage';
import {
  memberList,
  couponAddMember,
} from '@/api/api';
const formInfoData = {
  password: '',
};
export default {
  name: 'addMember',
  mixins: [mixin_list(memberList)],
  components: {
    myTable,
    FormPage,
    page,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!rule.required) {
        callback();
        return;
      }
      const reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;
      if (value === '') {
        callback(new Error(this.$t('memberManagement').passwordRule));
      } else {
        if (!reg.test(value)) {
          callback(new Error(this.$t('memberManagement').passwordRule));
        } else if (this.formInfo.data.password !== '') {
          callback();
        }
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (!rule.required) {
        callback();
        return;
      }
      const reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
      if (value === '') {
        callback(new Error('정확한 이메일 주소를 입력해 주세요.'));
      } else {
        if (!reg.test(value)) {
          callback(new Error('정확한 이메일 주소를 입력해 주세요.'));
        } else if (this.formInfo.data.password !== '') {
          callback();
        }
      }
    };
    return {
      filter: {
        search: '',
        is_library: '',
        is_publish: '',
        active: 1,
      },
      columns: [
        {
          label: 'ID',
          sortable: true,
          prop: 'id',
          width: 80,
        },
        {
          label: this.$t('memberManagement.username'),
          sortable: true,
          prop: 'username',
        },
        {
          label: this.$t('memberManagement.real_name'),
          sortable: true,
          prop: 'real_name',
        },
        {
          label: this.$t('memberManagement.phone'),
          sortable: true,
          prop: 'phone',
        },
      ],
      formInfo: {
        ref: null,
        disabled: false,
        data: formInfoData,
        fieldList: [
          {
            label: this.$t('memberManagement').username,
            value: 'username',
            type: 'input',
            width: '260',
            className: 'el-form-block',
            required: true,
            hidden: false,
            validator: validatePass1,
          },
          {
            label: this.$t('memberManagement').real_name,
            value: 'real_name',
            type: 'input',
            width: '260',
            className: 'el-form-block',
            required: true,
            hidden: false,
          },
          {
            label: this.$t('memberManagement').password,
            value: 'password',
            type: 'input',
            width: '260',
            className: 'el-form-block',
            // required: true,
            hidden: false,
            message: this.$t('memberManagement').passwordRule,
            validator: validatePass,
          },
        ],
        rules: {},
        labelWidth: '120px',
      },
      listTypeInfo: {},
      dialogFormVisible: false,
      which: '',
      selectedCount: 0,
      // 페이지 간 선택 상태 유지를 위한 전역 선택된 ID들
      globalSelectedIds: new Set(),
      // 현재 페이지의 선택 상태
      currentPageSelection: [],
      ignoreSelectionChange: false,
    };
  },
  watch: {
    // 페이지 변경 시 선택 상태 동기화
    page: {
      handler() {
        this.$nextTick(() => {
          this.syncSelectionAfterPageChange();
        });
      },
      immediate: true
    },
    // 페이지 크기 변경 시 선택 상태 동기화
    pageSize: {
      handler() {
        this.$nextTick(() => {
          this.syncSelectionAfterPageChange();
        });
      },
      immediate: true
    },
    // 데이터 변경 시 선택 상태 동기화
    'list_data.list': {
      handler() {
        this.$nextTick(() => {
          this.syncSelectionAfterPageChange();
        });
      },
      immediate: true
    }
  },
  computed: {
    title() {
      switch (this.which) {
        case 'add':
          return this.$t('btnTip').add;
        case 'edit':
          return this.$t('btnTip').edit;
        case 'change':
          return this.$t('btnTip').edit;
      }
    },
    buttonText() {
      switch (this.which) {
        case 'add':
          return this.$t('btnTip').submit;
        case 'edit':
          return this.$t('btnTip').submit;
        case 'change':
          return this.$t('btnTip').submit;
      }
    },
  },
  methods: {
    handleCheckAllChange(val) {
      if (val) {
        // 현재 페이지의 모든 항목을 전역 선택에 추가
        this.list_data.list.forEach(row => {
          this.globalSelectedIds.add(row.id);
        });
        this.$refs.myTable.$refs.table.toggleAllSelection();
      } else {
        // 현재 페이지의 모든 항목을 전역 선택에서 제거
        this.list_data.list.forEach(row => {
          this.globalSelectedIds.delete(row.id);
        });
        this.$refs.myTable.$refs.table.clearSelection();
      }
      this.selectedCount = this.globalSelectedIds.size;
      this.updateCurrentPageSelection();
    },
    
    handleSelectionChange(selection) {
      if (this.ignoreSelectionChange) return;

      // 현재 페이지의 모든 데이터에 대해 선택 상태 확인
      this.list_data.list.forEach(row => {
        if (selection.some(selectedRow => selectedRow.id === row.id)) {
          // 선택된 항목은 전역 선택에 추가
          this.globalSelectedIds.add(row.id);
        } else {
          // 선택 해제된 항목은 전역 선택에서 제거
          this.globalSelectedIds.delete(row.id);
        }
      });

      this.selectedCount = this.globalSelectedIds.size;

      // 현재 페이지 선택 상태 업데이트
      this.currentPageSelection = selection;
    },
    confirmSelection() {
      if (this.selectedCount === 0) {
        this.$message.warning('선택된 회원이 없습니다.');
        return;
      }
      
      // 전역에서 선택된 모든 데이터를 가져옴
      const allSelectedData = Array.from(this.globalSelectedIds).map(id => {
        // 현재 페이지에 있는 데이터는 현재 데이터 사용
        const currentPageData = this.list_data.list.find(row => row.id === id);
        if (currentPageData) {
          return currentPageData;
        }
        // 다른 페이지에 있는 데이터는 ID만 포함하여 전달
        return { id };
      });
      
      // 선택된 데이터를 부모 컴포넌트로 전달
      this.$emit('confirm-selection', allSelectedData);
      
      // 선택 상태 초기화
      this.clearGlobalSelection();
      
      this.$message.success(`${allSelectedData.length}명의 회원이 선택되었습니다.`);
    },
    async done(type) {
      if (type === 'close') {
        this.clearGlobalSelection();
        this.$emit('close');
        return;
      }
      
      if (type === 'all') {
        this.$confirm('전체 회원이 많을수록 등록에 시간이 소요됩니다. 전체 회원을 선택하시겠습니까?', '경고', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          type: 'warning',
        }).then(async () => {
          const data = {
            "coupon_id": this.$route.query.id,
            "user_ids": [],
            "assign_all_users": true
          }
          await couponAddMember(data);
          this.clearGlobalSelection();

          this.$emit('close');
        })

        return;

      } else {
        const data = {
          "coupon_id": this.$route.query.id,
          "user_ids": Array.from(this.globalSelectedIds),
          "assign_all_users": false
        }
        await couponAddMember(data);
        this.clearGlobalSelection();

        this.$emit('close');
      }
    },
    async handleSearch() {
      // 검색이나 필터 변경 시 선택 상태 초기화
      this.clearGlobalSelection();
      await this.get_list();
    },
    
    handleReset(fields) {
      // 리셋 시 선택 상태도 초기화
      this.clearGlobalSelection();
      // mixin의 reset 메서드 호출
      this.reset(fields);
    },
    // 페이지 변경 시 선택 상태 동기화
    syncSelectionAfterPageChange() {
      // 테이블이 완전히 렌더링될 때까지 대기
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.myTable && this.list_data.list.length > 0) {
            // 현재 페이지 선택 상태 업데이트
            this.updateCurrentPageSelection();
          }
        }, 200); // 200ms 대기하여 테이블 렌더링 완료 보장
      });
    },
    
    // 현재 페이지 선택 상태 업데이트
    updateCurrentPageSelection() {
      // 테이블 ref가 존재하고 데이터가 있을 때만 실행
      if (this.$refs.myTable && this.list_data.list.length > 0) {
        this.ignoreSelectionChange = true;

        // 현재 페이지의 데이터 중 전역에서 선택된 항목들을 체크
        this.list_data.list.forEach(row => {
          if (this.globalSelectedIds.has(row.id)) {
            console.log(this.globalSelectedIds);
            console.log('체크표시로 바꾸기', row.id);
            // Element UI의 el-table의 toggleRowSelection 메서드 사용
            this.$refs.myTable.$refs.table.toggleRowSelection(row, true);
          }
        });
      }
      
      // 전체 선택된 개수 업데이트
      this.selectedCount = this.globalSelectedIds.size;
      this.ignoreSelectionChange = false;
    },
    
    // 전역 선택 상태에 ID 추가
    addToGlobalSelection(id) {
      this.globalSelectedIds.add(id);
      this.selectedCount = this.globalSelectedIds.size;
    },
    
    // 전역 선택 상태에서 ID 제거
    removeFromGlobalSelection(id) {
      this.globalSelectedIds.delete(id);
      this.selectedCount = this.globalSelectedIds.size;
    },
    
    // 전역 선택 상태 초기화
    clearGlobalSelection() {
      this.globalSelectedIds.clear();
      this.selectedCount = 0;
      this.currentPageSelection = [];
      
      if (this.$refs.myTable && this.$refs.myTable.$refs.table) {
        this.$refs.myTable.$refs.table.clearSelection();
      }
      
    },
  },
};
</script>
<style scoped>

.text {
  width: 150px;
  font-size: 16px;
}
::v-deep label {
  margin-bottom: 0 !important;
}

.table-container {
  width: 100%;
}

.user-list {
  width: 100%;
  padding: 0 10px;
  margin-bottom: 90px;
  max-height: 60vh;
  overflow-y: auto;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.title-list {
  color: #292929;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 187.5% */
}

.title-check-box {
  color: #292929;
  text-align: right;

  /* Admin/Body 2 */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}

.title-selected {
  color: #495057;
  text-align: left;

  /* Caption 1 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
}

.title-selected-count {
  color: #ADB5BD;
}

.model-top-box {
  padding: 16px 20px;

  border-bottom: 1px solid #E6E6E6;
  background: #FFF;
}


.el-tag--default {
  border-radius: 5px;
  border: 1px solid #E9E9EB;

  background: #F4F4F5;
  color: #919399;
}

.pagin {
  margin-top: 20px;
  align-self: flex-end;
}

.dialog-footer {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  left: 0px;
  bottom: 0px;
  padding: 40px 20px;
  background: #fff;
  z-index: 1000;
}
</style>
